module.exports = __webpack_public_path__ + "img/LOGO_SELLIA-03.3433fa8c.svg";